import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import Moon from "@/components/Moon";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setSession } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const params = new URLSearchParams(location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    window.history.replaceState(null, "", window.location.pathname);

    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    api
      .post("/auth/google/session", { session_id: sessionId })
      .then(({ data }) => {
        setSession(data.token, data.user);
        navigate("/dashboard", { replace: true });
      })
      .catch(() => navigate("/login", { replace: true }));
  }, [location.hash, navigate, setSession]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-[#06080d]" data-testid="oauth-callback">
      <Moon size={100} />
      <p className="mt-8 font-mono text-xs uppercase tracking-[0.3em] text-zinc-500">Signing you in…</p>
    </div>
  );
}
